import { ProductsApiRemoteService } from '../../Services/api/products/products-service'
import { IGetVariantsByProductPayload, IGetVariantsByProductResponse } from '../../Services/api/products/products.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class GetVariantsByProductUseCase
implements IFormUsecase<IGetVariantsByProductPayload, IGetVariantsByProductResponse[]> {
  constructor (private readonly ProductsApi: ProductsApiRemoteService) {}
    

  public async handle (
    data: IGetVariantsByProductPayload
  ): Promise<Result<IGetVariantsByProductResponse[]>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.ProductsApi.getVariantsByProduct(data)

      if (response.isFailure) {
        return response
      }

      const variants = response.getValue()

      if (!variants) return response

    
      return Result.ok(variants)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
